import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/layouts/Sidebar';
import { Topbar } from '@/layouts/Topbar';
import { useEffect } from 'react';
import { useSettingsStore } from '@/app/store/settingsStore';
import { apiClient } from '@/services/api/axiosClient';
import { getStorageUrl } from '@/config/env';

export function AppLayout() {
  const setSettings = useSettingsStore(state => state.setSettings);
  const settings = useSettingsStore(state => state.settings);

  useEffect(() => {
    apiClient.get('/settings').then((res: any) => {
      setSettings(res.data);
    }).catch(console.error);
  }, [setSettings]);

  useEffect(() => {
    if (settings.app_favicon) {
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = getStorageUrl(settings.app_favicon);
    }
  }, [settings.app_favicon]);

  useEffect(() => {
    if (settings.meta_title) {
      document.title = settings.meta_title;
    } else if (settings.app_name) {
      document.title = settings.app_name;
    } else {
      document.title = "Document Management System";
    }
  }, [settings.meta_title, settings.app_name]);

  return (
    <div className="flex h-screen w-full bg-slate-50 overflow-hidden text-slate-900">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden bg-white/50 border-l border-slate-200 shadow-sm z-10 relative">
        <Topbar />
        <main className="flex-1 overflow-auto relative flex flex-col" id="main-content">
          <div className="flex-1 p-6">
            <Outlet />
          </div>
          <footer className="bg-white border-t border-slate-200 py-4 px-6 mt-auto">
            <div className="flex flex-col md:flex-row justify-between items-center text-sm text-slate-500">
              <div className="font-medium">
                {settings.app_copyright || '© 2026 DMS. All rights reserved.'}
              </div>
              <div>
                Developed by : <a href={settings.company_link || "#"} target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">{settings.developed_by || 'Virtoy Technology Pvt. Ltd.'}</a>
              </div>
            </div>
          </footer>
        </main>
      </div>
    </div>
  );
}
